import script from "./AuthLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthLayout.vue?vue&type=script&lang=ts&setup=true"

import "./AuthLayout.vue?vue&type=style&index=0&id=7caca9ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7caca9ac"]])

export default __exports__